import React, { useEffect, useState } from 'react';
import { getISOWeek } from 'date-fns';
import { useTranslation } from 'react-i18next';

import translations from 'services/translations/translations';

// The week is checked again this often, so it turns on a page left open over Sunday night
const CHECK_INTERVAL_MS = 60 * 1000;

// The current week of the year (ISO 8601, as in Finland), e.g. "vk 45"
const CurrentWeek = (): JSX.Element => {
  const { t } = useTranslation([translations.common]);
  const [week, setWeek] = useState(() => getISOWeek(new Date()));

  useEffect(() => {
    const interval = window.setInterval(
      () => setWeek(getISOWeek(new Date())),
      CHECK_INTERVAL_MS
    );

    return () => window.clearInterval(interval);
  }, []);

  return (
    <div
      className="current-week"
      title={t(`${translations.common}:Week`, { week })}
    >
      {t(`${translations.common}:Current week`, { week })}
    </div>
  );
};

export default CurrentWeek;
